const i18nConfig = {
  locales: ['en', 'es', 'esAr'],
  defaultLocale: 'en'
};

module.exports = i18nConfig;
